export default __webpack_public_path__ + "static/flipkartproductstatus-d1f4e288b5046fa01dc26f990cbd1c32.png";